// Admin Accounting Tabs Component
import { Box, Divider, Tab, Tabs, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { colors } from '@mui/material';
import PropTypes from 'prop-types';
import React, { memo, useEffect, useState } from 'react';
import RenderAccountingDashboardContent from './Components/RenderContent';

const useStyles = makeStyles((theme) => ({
  tabs: { margin: theme.spacing(3), marginBottom: 0 },
  tabsIndicator: {
    backgroundColor: '#40b5ad',
  },
  divider: {
    backgroundColor: colors.grey[300],
  },
  tab: {
    padding: '5px',
  },
}));

const AccountingTabs = memo(({ match, history }) => {
  const classes = useStyles();
  const { tab } = match.params;
  const [value, setValue] = useState(tab);

  const tabs = [
    { value: 'dashboard', label: 'Revenue' },
    { value: 'expense-dashboard', label: 'Expenses' },
  ];

  useEffect(() => {
    if (!tab) {
      return history.push('/admin/accounting/dashboard');
    }
    setValue(tab);
    document.title = tab === 'dashboard' ? 'Dashboard' : 'Expense Dashboard';
  }, [tab]);

  const handleTabsChange = (e, newValue) => {
    history.push(`/admin/accounting/${newValue}`);
  };

  return (
    <Box className={classes.content}>
      <Tabs
        className={classes.tabs}
        classes={{ indicator: classes.tabsIndicator }}
        value={value}
        onChange={handleTabsChange}
        variant='scrollable'
      >
        {tabs.map((t) => (
          <Tab key={t.value} value={t.value} label={<Typography>{t.label}</Typography>} />
        ))}
      </Tabs>
      <Divider className={classes.divider} />
      <div><RenderAccountingDashboardContent value={value} /></div>
    </Box>
  );
});

AccountingTabs.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default AccountingTabs;
